<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商户进件列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form
            :inline="true"
            :model="searchForm"
            :rules="searchRules"
            ref="searchForRef"
            label-width="80px"
            autocomplete="on"
            size="mini"
          >
            <el-form-item label="商户名称">
              <el-input v-model="searchForm.name" clearable type="text">

              </el-input>
            </el-form-item>
            <el-form-item label="所属代理" >
              <el-input v-model="searchForm.proxy_name" @click.native="showProxy" clearable type="text">
                <span slot="suffix" style="color: #ff0000">...</span>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="success"  @click="searchSubmit()">搜索</el-button>
            </el-form-item>
            <el-form-item >
              <el-button type="primary"  @click="addData">新增</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        stripe
        border
        size="mini"
      >
        <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>

        <el-table-column
          label="商户名称"
          width="130"
          :show-overflow-tooltip='true'
          prop="merchant_name"
        >
        </el-table-column>
        <el-table-column
          label="商户号"
          width="120"
          :show-overflow-tooltip='true'
          prop="merchant_no"
        >
        </el-table-column>
        <el-table-column
          label="APPID"
          width="130"
          :show-overflow-tooltip='true'
          prop="appid"
        >
        </el-table-column>
        <el-table-column
          label="联系人"
          :show-overflow-tooltip='true'
          prop="link_person"
        >
        </el-table-column>
        <el-table-column
          label="联系电话"
          :show-overflow-tooltip='true'
          prop="link_phone"
        >
        </el-table-column>
        <el-table-column
          label="身份证号"
          :show-overflow-tooltip='true'
          prop="credential_code"
        >
        </el-table-column>
        <el-table-column
          label="银行名称"
          :show-overflow-tooltip='true'
          prop="bank_name"
        >
        </el-table-column>
        <el-table-column
          label="银行卡号"
          :show-overflow-tooltip='true'
          prop="bank_account"
        >
        </el-table-column>
        <el-table-column
          label="商户类型"
          :show-overflow-tooltip='true'
          prop="sign_type"
        >
        </el-table-column>

        <el-table-column
          label="注册日期"
          width="115"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.add_time | dateFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="180">
          <template slot-scope="scope">
            <el-button  type="text" size="small" @click="del(scope.row)">删除</el-button>
            <el-button @click="handleClick(scope.row)"  type="text" size="small">编辑</el-button>
            <el-dropdown  size="mini"  split-button  trigger="click">
              更多
              <el-dropdown-menu slot="dropdown" trigger="click">
                <el-dropdown-item @click.native="goLs(scope.row)">乐刷</el-dropdown-item>
                <el-dropdown-item @click.native="goSft(scope.row)">盛付通</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->


    <eProxyList
      :formData="formData"
      :visible.sync="visible"
      :title="title"
      :closeForm="closeForm"
    />

  </div>
</template>
<script>
  import eProxyList from "../common/eProxyList.vue";
  import moment from 'moment'     //日期时间转换
  export default {
    name: "merList",
    components: {
      eProxyList
    },
    props: {},
    data() {
      return {
        formData:{},
        title: '',
        visible:false,

        // 搜索
        searchForm: {
          name: "",
          proxy_name:'',
          proxy_id:sessionStorage.getItem('proxy_id')
        },
        searchRules: {

        },
        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数

        showType: '',

        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入保司名称', trigger: 'blur' },
            {
              min: 3,
              max: 15,
              message: "长度在 3 到 15 个字符",
              trigger: "blur",
            }
          ],

        },

        dialogFormVisible: false,

        form: {
          name: '',
        },

      };
    },
    created() {
      // this.showType = this.$route.query.showType;
      // console.log(this.showType,888);
      this.DataList()
    },
    mounted() {
    },
    filters: {
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
    },
    methods: {
      goLs(row){
        this.$router.push({
          path:'/posMemberLsForm',
          query:{
            pos_member_id:row.id
          }
        })
      },
      goSft(row){
        this.$router.push({
          path:'/posMemberSftForm',
          query:{
            pos_member_id:row.id
          }
        })
      },
      closeForm(){
        this.title="";
        this.addForm.proxy_id=this.formData.id;
        this.visible=false;
      },
      showProxy(){
        this.title="所属代理";
        this.formData.pid=sessionStorage.getItem('proxy_id')
        this.visible=true;

      },
      handleClick(row){
        this.$router.push('/posMemberForm?id='+ row.id)
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      DataList(){
        let _this=this;
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          showType: this.showType,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          proxy_id:_this.searchForm.proxy_id
        }
        this.$axios.getPayMerchantList(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },

      // 新增
      addData() {
        this.$router.push('/posMemberForm')
      },
      handelEdit(index) {
        this.id = index.data.row.id
        this.title = '编辑'
        this.form = {
          name: this.name,
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index.data.row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },


      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.data.row.id,
          }
          this.$axios.insuranceCorpDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },
    },
  };
</script>
<style>

</style>
